import { ScrollView, View } from "tamagui";
import { customColorTokens } from "../../../tamagui.config";
import { NavigationProp, useNavigation } from "@react-navigation/native";
import { ProfileNavigatorParamList } from "../../navigators/ProfileNavigator";
import { Settings } from "@tamagui/lucide-icons";
import { FriendsAndRequests } from "../Club/FriendsAndRequests/FriendsAndRequests";
import { ProfileCardFlip } from "../Club/Profile/ProfileCardFlip";
import { Header } from "../../components/design-system/Header";
import { Pressable } from "react-native";

export const ProfileHome = () => {
  const navigation = useNavigation<NavigationProp<ProfileNavigatorParamList>>();

  return (
    <View
      flex={1}
      style={{ flex: 1, backgroundColor: customColorTokens.brandYellow }}
    >
      <Header
        title="Profile"
        headerRight={
          <Pressable onPress={() => navigation.navigate("EditProfile")}>
            <Settings width={16} height={16} />
          </Pressable>
        }
      />

      <ScrollView
        flex={1}
        bg={customColorTokens.brandParchment}
        contentContainerStyle={{
          backgroundColor: customColorTokens.brandParchment,
          paddingBottom: 100,
        }}
        showsVerticalScrollIndicator={false}
      >
        <View flex={1} py="$4">
          <ProfileCardFlip />
        </View>
        <FriendsAndRequests />
      </ScrollView>
    </View>
  );
};
